import React, { Component } from 'react';
import { render } from '@testing-library/react';
import { Container, Table, Row, Col} from 'react-bootstrap';

class Projects extends Component { 

    state = { displayImprint: false };

    toggleImprint = () => {
        this.setState({ displayImprint: !this.state.displayImprint })
    }

    render() {
        return (
            <Container>
                <Row>
                    <Col><h3>Projekterfahrung</h3></Col>
                </Row>
                <Row>
                    <Col>
                        <Table>
                            <tr>
                                <td>12/2019 - aktuell</td>
                                <td>
                                    <p>
                                        <strong>SAAS Application mit REST/JSON</strong><br /> 
                                        Umstellung auf eine Serverbasierte SAAS Anwendung
                                        <ul>
                                            <li>Sharepoint REST API</li>
                                            <li>MVC / REST API</li>
                                            <li>.Net CORE / C#</li>
                                        </ul>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td>06/2019 - 12/2019</td>
                                <td>
                                    <p>
                                        <strong>Java Legacy Application Refactoring</strong>
                                        <ul>
                                            <li>Unit Testing</li>
                                            <li>Refactoring nach Patterns</li>
                                        </ul>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td>07/2018 - 06/2019</td>
                                <td>
                                    <p>
                                        <strong>Microservice Entwicklung​</strong>
                                        <br />in Java zur automatisierten Sprachanalyse von Audiodateien 
                                        <ul>
                                            <li>Cloud NLP und ML Schnittstellen</li>
                                            <li>Docker und Kubernetes Architektur</li>
                                            <li>Reactive Microservices in Java </li>
                                        </ul>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td>07/2018 - 06/2019</td>
                                <td>
                                    <p>
                                        <strong>Continuous Integration und Deployment​</strong>
                                        <br />für Microservices mit Docker
                                        <ul>
                                            <li>Gitlab DevOps Pipeline</li>
                                            <li>Jenkins Einbindung</li>
                                            <li>Docker und Kubernetes Deployments</li>
                                        </ul>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td>02/2018 - 04/2018 </td>
                                <td>
                                    <p>
                                        <strong>Mehrsprachiges Reiseportal</strong>
                                        <br />mit REST Schnittstellen
                                        <ul>
                                            <li>Architektur Design</li>
                                            <li>Schnittstellen REST und JSON</li>
                                            <li>Datenbank Services</li>
                                        </ul>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td>06/2015 - 02/2018</td>
                                <td>
                                    <p>
                                        <strong>Treiberentwicklung im Broadcasting Bereich</strong>
                                        <ul>
                                            <li>Implementierung von Schnittstellen zwischen den Steuerungs- und Monitoring Systemen </li>
                                            <li>Treiberentwicklung (C#)</li>
                                            <li>Schnittstellen Architektur für Endgeräte im Broadcasting Bereich</li>
                                        </ul>
                                    </p>
                                </td>
                            </tr>
                        </Table>
                    </Col>
                </Row>
                <br />&nbsp;
            </Container>
        );
    }
}

export default Projects;
